/*
 *
 * File: actionCodes.js
 *
 * Purpose: Declarations of API action codes types as constants.
 *
 * Author:   Thomas Burgard (Software development)
 * Created:  01.03.2022
 * Modified: 02.05.2023
 *           - Insert new action code "GET_PASSENGER_BOOKINGS"
 * 
 * Copyright (c) DrivePartner GmbH 2022
 *
 */

export const GET_USERDATA = "get_userdata";
export const GET_PASSENGERDATA = "get_passengerdata";
export const GET_PASSENGER_BOOKINGS = "get_passengerBookings";
export const GET_BOOKINGDATA = "get_bookingdata";
export const SEND_BOOKINGDATA = "send_bookingdata";
export const CREATE_PAYMENT_INTENT = "create_payment_intent";
export const SEND_REGISTRATIONGDATA = "send_registrationdata";
export const CHANGE_BOOKINGDATA = "change_bookingdata";
export const CANCEL_BOOKING = "cancel_booking";